<div class="file-upload-root">
  <input type="file"
         (change)="onFileSelected($event)"
         [accept]="accept"
         #fileUpload
         class="file-upload-input">
  <div class="button-input-area">
    <app-primary-button id="file-input"
                        (click)="fileUpload.click()"
                        class="file-upload-button">
      {{labels.chooseFile}}
    </app-primary-button>
    <app-input class="file-upload-text-box" readonly [control]="fileNameControl"></app-input>
  </div>
</div>
